import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleGrid() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-xs font-semibold uppercase tracking-widest text-primary-600 mb-4">SEO Articles</p>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">AllChinaBuy Spreadsheet Guides & Resources</h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            In-depth articles covering everything from seller verification and shipping tips to category breakdowns and safe buying practices.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 border border-background-200/60 rounded-2xl overflow-hidden hover:border-primary-200/50 transition-all duration-200 cursor-pointer flex flex-col"
            >
              <div className="h-40 md:h-44 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 text-xs text-foreground-400 mb-2">
                  <span className="flex items-center gap-1"><i className="ri-time-line text-[10px]"></i>{article.readTime}</span>
                  <span className="flex items-center gap-1"><i className="ri-price-tag-3-line text-[10px]"></i>{article.mainKeyword.length > 25 ? article.mainKeyword.slice(0, 25) + '...' : article.mainKeyword}</span>
                </div>
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2 flex-1">
                  {article.description}
                </p>
                <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600 group-hover:gap-2 transition-all duration-200">
                  Read Article
                  <i className="ri-arrow-right-line text-[10px]"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/allchinabuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 border border-background-200/60 text-foreground-800 text-sm font-semibold rounded-full hover:bg-background-200 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            View Complete Shopping Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}